export const environment = {
  production: true,
  customerAbbreviation: 'Pandion',
  customerName: 'Pandion',
  defaultPath: '/general',
  baseApiUrl: 'https://apis-hca-dev-cu-001.azurewebsites.net',
  apiUrl: 'https://apis-hca-dev-cu-001.azurewebsites.net/api/'
};
